import { showLoginFormWithErrorMessage } from 'views/assets/scripts/subscription'
import { subscribe } from 'shared/store'
import { actionNames } from 'shared/store/ducks/userSession'
import { QNA_CONTAINER_ID, RATINGS_CONTAINER_ID } from 'views/consts'
import { HIDDEN_CLASS } from 'views/assets/scripts/consts'

const PRODUCT_DESCRIPTION_RATINGS_TAB_BUTTON =
  'ProductDescriptionRatingsTabButton'
const PRODUCT_DESCRIPTION_QNA_TAB_BUTTON = 'ProductDescriptionQnATabButton'

export const PRODUCT_DESCRIPTION_RATINGS_SELECTOR =
  '[data-clientside-hook~=ProductDescriptionRatings]'
const PRODUCT_DESCRIPTION_QNA_SELECTOR =
  '[data-clientside-hook~=ProductDescriptionQnA]'
const PRODUCT_RATING_FORM_SELECTOR = '[data-clientside-hook~=ProductRatingForm]'
const PRODUCT_RATING_LOGIN_FORM_SELECTOR =
  '[data-clientside-hook~=ProductRatingLoginForm]'

const PRODUCT_RATING_MODAL_BUTTON_SELECTOR =
  '[data-clientside-hook~=ProductRatingModalOpener]'
const ACTIVE_TAB_CLASSNAME = 'o-ProductDescriptionRatingsAndQnA__tab--active'

const handleButtonClick = tabId => {
  const ratingsTabButton = document.querySelector(
    `[data-clientside-hook~="${PRODUCT_DESCRIPTION_RATINGS_TAB_BUTTON}"]`
  )
  const qnaTabButton = document.querySelector(
    `[data-clientside-hook~="${PRODUCT_DESCRIPTION_QNA_TAB_BUTTON}"]`
  )

  if (!ratingsTabButton && !qnaTabButton) return

  const ratingsContainer = document.querySelector(
    PRODUCT_DESCRIPTION_RATINGS_SELECTOR
  )
  const qnaContainer = document.querySelector(PRODUCT_DESCRIPTION_QNA_SELECTOR)

  if (tabId === PRODUCT_DESCRIPTION_RATINGS_TAB_BUTTON) {
    if (
      ratingsTabButton &&
      !ratingsTabButton.classList.contains(ACTIVE_TAB_CLASSNAME)
    ) {
      qnaContainer.classList.add(HIDDEN_CLASS)
      ratingsContainer.classList.remove(HIDDEN_CLASS)
      ratingsTabButton.classList.add(ACTIVE_TAB_CLASSNAME)
      qnaTabButton.classList.remove(ACTIVE_TAB_CLASSNAME)
    }
  }

  if (tabId === PRODUCT_DESCRIPTION_QNA_TAB_BUTTON) {
    if (!qnaTabButton.classList.contains(ACTIVE_TAB_CLASSNAME)) {
      qnaTabButton.classList.add(ACTIVE_TAB_CLASSNAME)
    }
    ratingsTabButton.classList.remove(ACTIVE_TAB_CLASSNAME)
    ratingsContainer.classList.add(HIDDEN_CLASS)
    qnaContainer.classList.remove(HIDDEN_CLASS)
  }
}

export default () => {
  const ratingsTabButton = document.querySelector(
    `[data-clientside-hook~="${PRODUCT_DESCRIPTION_RATINGS_TAB_BUTTON}"]`
  )
  const qnaTabButton = document.querySelector(
    `[data-clientside-hook~="${PRODUCT_DESCRIPTION_QNA_TAB_BUTTON}"]`
  )
  const productDescriptionTabButtons = [ratingsTabButton, qnaTabButton]

  if (ratingsTabButton && qnaTabButton) {
    productDescriptionTabButtons.forEach(button => {
      const tabId = button.getAttribute('data-clientside-hook')
      button.addEventListener('click', () => handleButtonClick(tabId))
    })
  }

  document
    .querySelectorAll(`[href="#${RATINGS_CONTAINER_ID}"]`)
    .forEach(element => {
      element.addEventListener('click', () =>
        handleButtonClick(PRODUCT_DESCRIPTION_RATINGS_TAB_BUTTON)
      )
    })

  document
    .querySelectorAll(`[href="#${QNA_CONTAINER_ID}"]`)
    .forEach(element => {
      element.addEventListener('click', () =>
        handleButtonClick(PRODUCT_DESCRIPTION_QNA_TAB_BUTTON)
      )
    })

  const { hash } = window?.location

  // Wait until the page is loaded completely
  window.addEventListener('load', () => {
    if (hash.includes(`#${RATINGS_CONTAINER_ID}`)) {
      handleButtonClick(PRODUCT_DESCRIPTION_RATINGS_TAB_BUTTON)

      setTimeout(() => {
        document
          .querySelector(`[data-id='${RATINGS_CONTAINER_ID}']`)
          .scrollIntoView()
      }, 200)
    }
  })

  subscribe.after.once(actionNames.setUserSession, ({ userSession }) => {
    const productRatingLoginForm = document.querySelector(
      PRODUCT_RATING_LOGIN_FORM_SELECTOR
    )
    const productRatingForm = document.querySelector(
      PRODUCT_RATING_FORM_SELECTOR
    )

    if (!productRatingLoginForm && !productRatingForm) {
      return
    }

    if (userSession.isLoggedIn) {
      productRatingLoginForm.classList.add(HIDDEN_CLASS)
      if (hash.includes('with-login')) {
        document.querySelector(PRODUCT_RATING_MODAL_BUTTON_SELECTOR).click()
      }
    } else {
      productRatingForm.classList.add(HIDDEN_CLASS)
      if (hash.includes('with-login')) {
        showLoginFormWithErrorMessage()
      }
    }
  })
}
